import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isAndroidNative, isQuickFillPickPending } from "@/lib/quickfillBridge";

/**
 * On Android, when the system autofill bar entry "Open TestAssets" is
 * tapped, the OS launches MainActivity via an IntentSender. The native
 * side stores a pending AutofillId; this component polls for it after
 * the SPA boots and navigates to the picker page when set.
 */
const QuickFillPickerBootstrap = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isAndroidNative()) return;
    let cancelled = false;

    const check = async () => {
      const pending = await isQuickFillPickPending();
      if (!pending || cancelled) return;
      if (location.pathname !== "/quickfill-picker") {
        navigate("/quickfill-picker?source=autofill", { replace: true });
      }
    };

    // Initial check + a couple of follow-ups in case the activity was
    // brought to the foreground after the SPA was already mounted.
    check();
    const t1 = setTimeout(check, 250);
    const t2 = setTimeout(check, 1000);

    const onVisibility = () => {
      if (document.visibilityState === "visible") check();
    };
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      cancelled = true;
      clearTimeout(t1);
      clearTimeout(t2);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [navigate, location.pathname]);

  return null;
};

export default QuickFillPickerBootstrap;